module.exports = __webpack_public_path__ + "img/geodir-entel-logo.195109fa.png";